import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import '../FileCard.css';
import toast from 'react-hot-toast';



function FileCard({ file, onDelete, onMove, folders, isPaid }) {
  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);



  

  const BACKEND_URL =
    process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const isImage = file.file_type.startsWith('image/');
  const isPDF = file.file_type === 'application/pdf';
  const isDOCX =
    file.file_type ===
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  // ✅ FINAL resolved URL
const resolvedUrl = file.file_url;

 const handleDelete = (e) => {
  e.stopPropagation();
  setShowDeleteConfirm(true);
};



  const handleMove = (e, folderName) => {
    e.stopPropagation();
    if (file.folder !== folderName) {
      onMove(file.id, folderName);
    }
  };

  const handleClick = () => {
  if (isPDF) {
    window.open(
      `${file.file_url}?response-content-disposition=inline`,
      '_blank'
    );
  } else {
    window.open(file.file_url, '_blank');
  }
};


const handleShare = async (e) => {
  e.stopPropagation();

  try {
    const res = await fetch(
      `${BACKEND_URL}/files/share/${file.id}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    if (!res.ok) throw new Error('Share failed');

    const data = await res.json();
    const shareUrl = data.shareUrl;

    if (!shareUrl) throw new Error('No share URL');

    // ✅ NATIVE SHARE (BIG APPS UX)
    if (navigator.share) {
      await navigator.share({
        title: file.file_name,
        text: 'Check out this file',
        url: shareUrl
      });
    } else {
      // ❌ FALLBACK (DESKTOP / OLD BROWSERS)
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Share link copied');
    }
  } catch (err) {
    toast.error('Failed to share file');
  }
};




  const getFolderIcon = (folderName) => {
    const folder = folders?.find(f => f.folder_name === folderName);
    return folder?.icon || '';
  };

  return (
    <div
      className="file-card position-relative"
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}
      onClick={handleClick}
    >
      {showDeleteConfirm && (
  <div
    className="inline-delete-confirm"
    onClick={(e) => e.stopPropagation()}
  >
    <p>Delete this file?</p>
    <span>This action cannot be undone.</span>

    <div className="confirm-actions">
      <button
        className="cancel-btn"
        onClick={() => setShowDeleteConfirm(false)}
      >
        Cancel
      </button>

      <button
        className="confirm-delete-btn"
        onClick={() => {
          onDelete(file.id);
          setShowDeleteConfirm(false);
          toast.success('File deleted');
        }}
      >
        Delete
      </button>
    </div>
  </div>
)}

      {showDelete && (
        <div className="file-card-actions">
          {isPaid && folders && folders.length > 0 && (
            <Dropdown onClick={(e) => e.stopPropagation()}>
              <Dropdown.Toggle
                variant="light"
                size="sm"
                className="move-btn"
              >
                Move
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {folders.map(folder => (
                  <Dropdown.Item
                    key={folder.folder_name}
                    active={file.folder === folder.folder_name}
                    onClick={(e) =>
                      handleMove(e, folder.folder_name)
                    }
                  >
                    {folder.folder_name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}

          <button
            className="delete-btn"
            onClick={handleDelete}
            title="Delete file"
          >
            Delete
          </button>
        </div>
      )}

      {isImage ? (
        <img
          src={resolvedUrl}
          alt={file.file_name}
          className="file-thumbnail"
        />
      ) : (
        <div className="file-icon-container">
          {isPDF ? '📄' : isDOCX ? '📝' : '📋'}
        </div>
      )}

      <div className="file-info">
        {isPaid && file.folder && (
          <div className="file-folder-badge">
            {getFolderIcon(file.folder)} {file.folder}
          </div>
        )}

        <div className="file-name" title={file.file_name}>
          {file.file_name}
        </div>

        <div className="file-date">
          {formatDate(file.created_at)}
        </div>

        {file.keywords?.length > 0 && (
          <>
            <div className="text-muted small mt-2">
              Detected keywords:
            </div>
            <div className="file-keywords">
              {file.keywords.map((keyword, index) => (
                <span key={index} className="keyword-badge">
                  {keyword}
                </span>
              ))}
            </div>
          </>
        )}

        {/* ACTION BUTTONS */}
        <div className="file-bottom-actions">
          <a
            href={resolvedUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="view-btn"
          >
            View
          </a>

          <button
            className="share-btn"
            onClick={handleShare}
            title="Share file"
          >
            Share
          </button>
        </div>
      </div>
    </div>
  );
}

export default FileCard;
